export default "/build/images/oscar.png?72d46096847dfe229eceffc03f6d4012";